module.exports = ".mat-form-field {\n  width: 200px; }\n"